import React, { useEffect, useRef, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { axiosInstance } from '../Config'
import Loader from '../Loader'

const onlyDigits = (e) => { if (!/[0-9]/.test(e.key)) e.preventDefault() }

const EditCreator = () => {
    const { creatorId } = useParams()
    const navigate = useNavigate()

    const [photoPreview, setPhotoPreview] = useState(null)
    const [photoFile, setPhotoFile] = useState(null)
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)

    const fileRef = useRef(null)

    useEffect(() => {
        document.title = 'Edit Creator | Mindora'
        window.scrollTo(0, 0)
        fetchCreator()
    }, [creatorId])

    const fetchCreator = async () => {
        setLoading(true)
        try {
            const res = await axiosInstance.get(`creators/${creatorId}`)
            const data = res.data?.data ?? res.data
            setName(data.name || '')
            setEmail(data.email || '')
            setPhone(data.phone || '')
            if (data.photo) setPhotoPreview(data.photo)
        } catch {
            toast.error('Failed to load creator.')
        } finally {
            setLoading(false)
        }
    }

    const validate = () => {
        const e = {}
        if (!name.trim()) e.name = 'Name is required'
        if (!email.trim()) e.email = 'Email is required'
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = 'Invalid email format'
        if (!phone.trim()) e.phone = 'Phone number is required'
        else if (phone.length !== 10) e.phone = 'Phone must be 10 digits'
        setErrors(e)
        return Object.keys(e).length === 0
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!validate()) return
        setLoading(true)
        try {
            const formData = new FormData()
            formData.append('name', name)
            formData.append('email', email)
            formData.append('phone', phone)
            if (photoFile) formData.append('photo', photoFile)
            await axiosInstance.put(`creators/${creatorId}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            toast.success('Creator updated successfully!')
            navigate(-1)
        } catch (err) {
            toast.error(err.response?.data?.message || 'Failed to update creator.')
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Edit Creator" description="Update creator information">
                <div className="p-4 py-5 bg-gradientt rounded-4">
                    <section className="ps-dashboards" id="homepages">
                        <form onSubmit={handleSubmit} className="therapist-profile-form">
                            <div className="row px-md-5">

                                {/* Photo */}
                                <div className="col-12 d-flex justify-content-center mb-4">
                                    <div className="tutor-avatar-upload" onClick={() => fileRef.current.click()}>
                                        {photoPreview
                                            ? <img src={photoPreview} alt="Creator" />
                                            : <div className="tutor-avatar-placeholder">
                                                <i className="bi bi-person" style={{ fontSize: 40, color: 'var(--primary)' }}></i>
                                              </div>
                                        }
                                        <div className="tutor-avatar-edit">
                                            <i className="bi bi-camera-fill"></i>
                                        </div>
                                    </div>
                                    <input ref={fileRef} type="file" accept="image/*" hidden
                                        onChange={(e) => {
                                            const file = e.target.files[0]
                                            if (file) {
                                                setPhotoFile(file)
                                                setPhotoPreview(URL.createObjectURL(file))
                                            }
                                        }} />
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="name" className='label'>
                                            <input type="text" id="name" placeholder="Name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)} />
                                            <span>Full Name <i className='text-danger'>*</i></span>
                                        </label>
                                    </div>
                                    {errors.name && <span className='badge text-danger span-error'>{errors.name}</span>}
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="email" className='label'>
                                            <input type="text" id="email" placeholder="Email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value.toLowerCase())} />
                                            <span>Email <i className='text-danger'>*</i></span>
                                        </label>
                                    </div>
                                    {errors.email && <span className='badge text-danger span-error'>{errors.email}</span>}
                                </div>

                                <div className="col-md-6 px-4">
                                    <div className="input-field">
                                        <label htmlFor="phone" className='label'>
                                            <input type="text" id="phone" placeholder="Phone Number"
                                                value={phone} maxLength={10} onKeyPress={onlyDigits}
                                                onChange={(e) => setPhone(e.target.value)} />
                                            <span>Phone Number <i className='text-danger'>*</i></span>
                                        </label>
                                    </div>
                                    {errors.phone && <span className='badge text-danger span-error'>{errors.phone}</span>}
                                </div>

                                <div className="col-12 text-center mt-5">
                                    <button type="button" onClick={() => navigate(-1)}
                                        className="button me-4"
                                        style={{ background: '#1a1a2e', color: '#fff', borderRadius: '12px' }}>
                                        <i className='icon-arrow-left me-2'></i>Back
                                    </button>
                                    <button type="submit" className="btn-green button" disabled={loading}>
                                        <i className={`bi bi-${loading ? 'arrow-repeat rotation' : 'save'} me-2`}></i>
                                        Update
                                    </button>
                                </div>

                            </div>
                        </form>
                    </section>
                </div>
            </ContainerDashboard>
        </>
    )
}

export default EditCreator
